import React, { memo } from 'react';

import { Pagination, Space, Table as AntTable } from 'antd';
import PropTypes from 'prop-types';

import EditableCell from './EditableCell';
import EditableRow from './EditableRow';

function Table({
  columns,
  dataSource,
  handleSave,
  rowKey,
  setPagination,
  totalItens,
  ...propsTable
}) {
  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  const newColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        handleSave,
        cursor: col.cursor,
        editable: col.editable,
        editableField: col.editableField,
        dataIndex: col.dataIndex,
        title: col.title,
      }),
    };
  });

  return (
    <Space direction="vertical" size="middle">
      <AntTable
        components={components}
        columns={newColumns}
        dataSource={dataSource}
        pagination={false}
        rowKey={rowKey}
        size="small"
        {...propsTable}
      />

      <Pagination
        hideOnSinglePage
        showSizeChanger
        size="small"
        total={totalItens}
        showTotal={(total, range) => {
          return `${range[0]}-${range[1]} de ${total} ite${total > 1 ? 'ns' : 'm'}`;
        }}
        defaultPageSize={20}
        onChange={(page, pageSize) => setPagination((prev) => ({ ...prev, page, pageSize }))}
      />
    </Space>
  );
}

Table.defaultProps = {
  handleSave: () => null,
  rowKey: 'id',
  setPagination: () => null,
  totalItens: 0,
};

Table.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  dataSource: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleSave: PropTypes.func,
  rowKey: PropTypes.string,
  setPagination: PropTypes.func,
  totalItens: PropTypes.number,
};

export default memo(Table);
